import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { KundenPopoverPage } from './kunden-popover.page';

const routes: Routes = [
  {
    path: '',
    component: KundenPopoverPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class KundenPopoverPageRoutingModule {}
